/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-top': {
    width: 15,
    height: 9,
    viewBox: '0 0 15 9',
    data: '<path pid="0" d="M13.582 8L7.783 1 1.985 8" _stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
